import { List, Record } from 'immutable';
import find from 'lodash/find';
const ValudeDomainModelRecord = Record({
    value: null,
    include: true,
    $extra: null,
    $errors: List(),
    $rcc: null,
    $isDirty: false
});
export class ValueDomainModel extends ValudeDomainModelRecord {
    getValue(options) {
        if (!this.value) {
            return null;
        }
        if (!options) {
            return this.value;
        }
        const result = find(options, (x)=>x.id === this.value);
        if (!result) {
            throw new Error(`The value ${this.value} could not be found from the supplied options.`);
        }
        return result;
    }
    setValue(value, options) {
        let result = this.set('value', value);
        if (options?.washField) {
            result = result.set('$isDirty', false);
        }
        if (options?.markAsDirty) {
            result = result.set('$isDirty', true);
        }
        return result;
    }
    errorsOutOfSync(errors) {
        const curErrors = this.$errors;
        // Kassa immutable-bindings - err kan inte vara undefined, se https://github.com/immutable-js/immutable-js/issues/1246
        return curErrors.count() !== errors.length || curErrors.some((err)=>!find(errors, (e)=>e.isFatal === err.isFatal && e.message === err.message && e.rule === err.rule));
    }
    setValidationErrors(errors) {
        if (this.errorsOutOfSync(errors)) {
            return this.set('$errors', List(errors));
        }
        return this;
    }
    toIncaJS() {
        return {
            ...this.$extra,
            value: this.value,
            include: this.include
        };
    }
}
